import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import './Layout.css';

/** App shell — header with brand + nav + user menu. Body is whatever
 *  the matched route renders via <Outlet/>. */
export function Layout() {
  const auth = useAuth();
  const navigate = useNavigate();

  async function handleLogout(): Promise<void> {
    await auth.logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="layout">
      <header className="layout__header">
        <Link to="/" className="layout__brand">Breww AI</Link>
        <nav className="layout__nav">
          <NavLink to="/chat">Chat</NavLink>
          <NavLink to="/connectors">Connectors</NavLink>
          <NavLink to="/plans">Plans</NavLink>
          {/* Brain is internal wrapper telemetry — admin-only. It dead-ends on
              "admin role required" for regular users, so it's hidden from them
              (route still reachable by URL for admins). */}
          {auth.user?.role === 'admin' && <NavLink to="/brain">Brain</NavLink>}
          {auth.user?.role === 'admin' && <NavLink to="/admin">Admin</NavLink>}
        </nav>
        <div className="layout__user">
          {auth.user ? (
            <>
              <span title={auth.user.email}>{auth.user.name || auth.user.email}</span>
              <button type="button" onClick={handleLogout} className="layout__logout">Sign out</button>
            </>
          ) : (
            <Link to="/login" className="layout__login-link">Sign in</Link>
          )}
        </div>
      </header>
      <main className="layout__main">
        <Outlet />
      </main>
    </div>
  );
}
